import DoNotDisturb from "@mui/icons-material/DoNotDisturb";
import { CircularProgress, SxProps } from "@mui/material";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

import DoesntNeedResponseBullet from "./DoesntNeedResponseBullet";
import NeedsResponseBullet from "./NeedsResponseBullet";

const iconWithColor = (color?: string): SxProps => ({
  alignSelf: "flex-start",
  marginTop: "12px",
  width: "10px",
  height: "10px",
  marginRight: "4px",
  color,
});

export default function ThreadIcon({
  needsTexterResponse,
  isOptedOut,
  isLoading,
}: {
  needsTexterResponse: boolean;
  isOptedOut: boolean;
  isLoading?: boolean;
}): ReactElement {
  if (isLoading) {
    return <CircularProgress size={10} sx={iconWithColor(palette.navy)} />;
  }

  if (isOptedOut) {
    return <DoNotDisturb sx={iconWithColor(palette.navy)} />;
  }

  if (needsTexterResponse) {
    return <NeedsResponseBullet sx={iconWithColor(palette.darkGreen)} />;
  }

  return <DoesntNeedResponseBullet sx={iconWithColor(palette.darkGray)} />;
}
